import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import {
  db,
  getDoc,
  doc,
  query,
  collection,
  where,
  getDocs,
  setDoc,
} from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SmartScreenOutlinedIcon from "@mui/icons-material/SmartScreenOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import AdminReviewsPartials from "./AdminReviewsPartials";
import AdminPurchasesPartials from "./AdminPurchasesPartials";
import AdminBlockAUser from "./AdminBlockAUser";
import Pagination from "@mui/material/Pagination";
import AdminCheck from "./AdminCheck";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const AdminDashboard = () => {
  const { t, i18n } = useTranslation();
  let currentLocation = JSON.parse(
    window.sessionStorage.getItem("iplookup")
  ).countryCode;

  currentLocation = "KO";
  const numOfReviews = 5;
  const numOfPurchase = 5;
  let { id } = useParams();
  let navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [address, setAddress] = useState([]);
  const [reviews, setReviews] = useState([]);

  const [purchases, setPurchases] = useState([]);

  const [newPosition, setNewPosition] = useState("user");
  const [secret, setSecret] = useState(null);
  const [alert, setAlert] = useState(null);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  console.log("user *********", user);

  const changeStatus = () => {
    handleOpen();
  };
  const changePosition = async () => {
    const docRef = doc(db, "secret", "code");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      if (+secret === docSnap.data().code) {
        await setDoc(
          doc(db, "users", id),
          { position: newPosition },
          { merge: true }
        );
        setAlert(t("New position is set. Thank you."));
        setTimeout(() => {
          setAlert(null);
          setSecret(null);
          handleClose();
        }, 1000);
      } else {
        setAlert(t("Secret code is not matched. Try again."));
        setTimeout(() => {
          setSecret(null);
          setAlert(null);
        }, 1000);
      }
    } else {
      setAlert("New position is set. Thank you.");
      setTimeout(() => {
        setAlert(null);
        setSecret(null);
        handleClose();
      }, 1000);
    }
  };

  useEffect(() => {
    setUser([]);
    getUser();
    setAddress([]);
    getAddress();
  }, []);

  const getUser = async () => {
    const docRef = doc(db, "users", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setUser({ ...docSnap.data(), id: docSnap.id });
    } else {
      navigate("/admin/dashboard");
    }
  };
  const getAddress = async () => {
    const querySnapshot = await getDocs(collection(db, "users", id, "address"));
    querySnapshot.forEach((doc) => {
      setAddress((old) =>
        old.concat({
          ...doc.data(),
          id: doc.id,
        })
      );
    });
  };
  const refresh = () => {
    let list = [];

    setReviews([]);
    const unique = [...new Set(user?.reviews)];

    unique.map(async (reviewId) => {
      const newreviewId = reviewId.replaceAll("reviews_", "");
      const q = query(collection(db, reviewId), where("uid", "==", id));

      console.log(currentLocation + "_" + reviewId);

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        list = list.concat({
          ...doc.data(),
          id: doc.id,
          productId: newreviewId,
        });
      });

      const sorted = [...list].sort((a, b) => {
        return b.created - a.created;
      });
      setReviews(sorted);
    });
  };
  console.log("user?.reviews", user?.reviews);
  const getReviews = async () => {
    let list = [];

    setReviews([]);
    const unique = [...new Set(user?.reviews)];

    unique.map(async (reviewId) => {
      const newreviewId = reviewId.replaceAll("reviews_", "");
      const q = query(collection(db, reviewId), where("uid", "==", id));
      console.log("reviewDBName", reviewId);

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        list = list.concat({
          ...doc.data(),
          id: doc.id,
          productId: newreviewId,
          reviewDBName: reviewId,
        });
      });

      const sorted = [...list].sort((a, b) => {
        return b.created - a.created;
      });
      setReviews(sorted);
    });
  };

  const getPurchases = async () => {
    let list = [];
    setPurchases([]);
    const unique = [...new Set(user?.purchases)];

    const q = query(
      collection(db, currentLocation + "_" + "orders"),
      where("user_uid", "==", id)
    );

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      list = list.concat({
        ...doc.data(),
        id: doc.id,
      });
    });

    const sorted = [...list].sort((a, b) => {
      return b.created - a.created;
    });
    setPurchases(sorted);
  };

  useEffect(() => {
    getReviews();
    getPurchases();
  }, [user]);

  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    console.log(value);
  };

  const [page_review, setPage_review] = React.useState(1);
  const handleChangeReview = (event, value) => {
    setPage_review(value);
    console.log(value);
  };

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6" }}
          >
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  <AdminPanelSettingsOutlinedIcon
                    sx={{ position: "relative", top: "+3px" }}
                  />{" "}
                  {t("Elevated privileges of this user")}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  {t("Change the position of this user.")}
                  <FormControl fullWidth sx={{ mt: 3 }}>
                    <InputLabel id="demo-simple-select-label">
                      Position
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={newPosition}
                      label="Age"
                      onChange={(e) => setNewPosition(e.target.value)}
                    >
                      <MenuItem value={"user"}>{t("User")}</MenuItem>
                      <MenuItem value={"manager"}>{t("Manager")}</MenuItem>
                      <MenuItem value={"admin"}>{t("Administrator")}</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    variant="filled"
                    label={t("Enter a secret code to proceed")}
                    sx={{ width: 1, mt: 2 }}
                    inputProps={{ maxLength: 6 }}
                    value={secret}
                    onChange={(e) => setSecret(e.target.value)}
                  />
                </Typography>
                <Box
                  sx={{ py: 1, pt: 2, textAlign: "center", color: "#0d47a1" }}
                >
                  {alert}
                </Box>
                <button
                  onClick={changePosition}
                  className="custom_btn"
                  style={{ marginTop: "20px" }}
                >
                  {t("Submit")}
                </button>
              </Box>
            </Modal>
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "22px" }}>{t("User")}</Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  Manage Admins
                </Box> */}
              </Box>
              <Box
                sx={{
                  mt: 2,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "20px",
                }}
              >
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    backgroundColor: "white",
                    p: { md: 4, sm: 1 },
                    textAlign: "center",
                    py: 2,
                  }}
                >
                  {user?.firstname} {user?.lastname}
                </Box>
              </Box>
              <Grid container>
                <Grid item md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      mr: { md: 5, sm: 0, xs: 0 },
                      backgroundColor: "white",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>{t("User Information")}</Box>
                      <Box
                        sx={{
                          color: "red",
                          cursor: "pointer",
                          fontSize: "13px",
                          display: "flex",
                          textDecoration: "underline",
                        }}
                      >
                        <AdminBlockAUser id={id} getUser={getUser} />
                        <Box
                          sx={{
                            color: "#ffa733",
                            pl: 2,
                            textDecoration: "underline",
                          }}
                          onClick={changeStatus}
                        >
                          {t("Elevated privileges")}
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        py: 2,
                        px: 4,
                        lineHeight: "2.2em",
                      }}
                    >
                      <Box>
                        {t("fn")}: {user?.firstname}
                      </Box>
                      <Box>
                        {t("ln")}: {user?.lastname}
                      </Box>
                      <Box>
                        {t("Member Since")}:{" "}
                        {user?.created?.toDate().getFullYear() +
                          "/" +
                          String(user?.created?.toDate().getMonth()).padStart(
                            2,
                            "0"
                          ) +
                          "/" +
                          String(user?.created?.toDate().getDate()).padStart(
                            2,
                            "0"
                          ) +
                          " " +
                          String(user?.created?.toDate().getHours()).padStart(
                            2,
                            "0"
                          ) +
                          ":" +
                          String(user?.created?.toDate().getMinutes()).padStart(
                            2,
                            "0"
                          )}
                      </Box>
                      <Box>
                        {t("User Location")}: {user?.location}
                      </Box>
                      <Box>
                        {t("Language")}:{" "}
                        {user?.language === "en" ? "English" : null}
                        {user?.language === "ko" ? "Korean" : null}
                      </Box>
                      <Box>
                        {t("Email")}:{" "}
                        <a href={"mailto:" + user?.email} className="pink_link">
                          {user?.email}
                        </a>
                      </Box>
                      {user?.block ? (
                        <Box>
                          차단 여부:{" "}
                          <span style={{ color: "red" }}>댓글 차단됨</span>
                        </Box>
                      ) : null}

                      <Box
                        sx={{
                          pt: 2,
                          borderBottom: "1px solid lightgray",
                          pb: 1,
                        }}
                      >
                        {address
                          ? address.map((add, idx) => {
                              return (
                                <div>
                                  {t("Address")} {idx + 1}: {add.lastname}{" "}
                                  {add.firstname} {add.address} {add.apt}{" "}
                                  {add.city} {add.city} {add.state}{" "}
                                  {add.zipcode}
                                </div>
                              );
                            })
                          : null}
                      </Box>
                      <Box
                        sx={{
                          pt: 1,
                          borderBottom: "1px solid lightgray",
                          pb: 2,
                        }}
                      >
                        <SmartScreenOutlinedIcon
                          sx={{
                            position: "relative",
                            top: "+5px",
                          }}
                        />
                        &nbsp; {t("Reviews")} ({t("Total")} {reviews?.length}{" "}
                        {t("review")}
                        {reviews?.length > 1 ? "s" : null}. 한 페이지에{" "}
                        {numOfReviews}개의 리뷰가 보입니다.){" "}
                        {/* <Box sx={{ display: "flex" }}>
                          {reviews.length > 0 ? (
                            <Box
                              sx={{ paddingTop: "12px", pr: 2, color: "gray" }}
                            >
                              Page
                            </Box>
                          ) : null}
                          {Array.apply(null, {
                            length: Math.ceil(reviews.length / numOfReviews),
                          }).map((e, i) => {
                            if (currentPage === i) {
                              return (
                                <Box
                                  key={i}
                                  sx={{
                                    border: "1px solid lightgray",
                                    margin: "2px",
                                    paddingLeft: "10px",
                                    paddingRight: "10px",
                                    py: 1,
                                    color: "#153a5a",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                  onClick={(e) => setCurrentPage(i)}
                                >
                                  {i + 1}
                                </Box>
                              );
                            } else {
                              return (
                                <Box
                                  key={i}
                                  sx={{
                                    border: "1px solid lightgray",
                                    margin: "2px",
                                    paddingLeft: "10px",
                                    paddingRight: "10px",
                                    py: 1,
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => setCurrentPage(i)}
                                >
                                  {i + 1}
                                </Box>
                              );
                            }
                          })}
                        </Box> */}
                        <Box sx={{ pt: 1 }}>
                          <Pagination
                            count={Math.ceil(reviews.length / numOfReviews)}
                            variant="outlined"
                            color="secondary"
                            sx={{ my: 2 }}
                            onChange={handleChangeReview}
                            page={page_review}
                          />
                          <AdminReviewsPartials
                            reviews={reviews.slice(
                              page_review - 1 * numOfReviews,
                              numOfReviews * (page_review + 1)
                            )}
                            refresh={refresh}
                          />
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          pt: 2,
                          pb: 2,
                        }}
                      >
                        <LocalMallOutlinedIcon
                          sx={{
                            position: "relative",
                            top: "+5px",
                          }}
                        />
                        &nbsp; {t("Purchases")} ({t("Total")}{" "}
                        {purchases?.length}개의 {t("purchase")}가 있습니다.){" "}
                        <Box sx={{ pb: 3 }}>
                          <Pagination
                            count={Math.ceil(purchases.length / numOfPurchase)}
                            variant="outlined"
                            color="secondary"
                            sx={{ my: 2 }}
                            onChange={handleChange}
                            page={page}
                          />
                          <AdminPurchasesPartials
                            purchases={purchases.slice(
                              (page - 1) * numOfPurchase,
                              numOfPurchase * page
                            )}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
// users
